import React from 'react'
import {Link, NavLink, withRouter} from 'react-router-dom'
//images
import State from '../img/nrw.png';


const School = () => {
    return(
        <section className="ftco-section contact-section ftco-no-pb">
          <div className="container">
            <div className="row justify-content-center mb-1 pb-3">
              <div className="col-md-12 heading-section text-center ">
                <h4 className="float-left"><strong> Regulations in NRW</strong></h4> 
                <div className="img d-flex align-self-stretch align-items-flex-end split-left">
                  <img className=" float-left img-fluid"
                  width="300" height="400"
                  src={State} alt="state" /> 
                  <div className="container">      
                    <div> 
                      <ul className="nav navbar-collapse nav-fill ml-5" style={{backgroundColor: '#E4DADA'}}>
                        <li className="nav-item2 mr-auto">
                          <Link to="/nrw"><span className="nav-link">General</span></Link>
                        </li>
                        <li className="nav-item2 mr-auto">
                          <Link to="/leisure"><span className="nav-link">Leisure Time</span></Link>
                        </li>
                        <li className="nav-item2 mr-auto">
                          <span className="nav-link">School & Kindergardens</span>
                        </li>
                        <li className="nav-item2 mr-auto">
                          <Link to="/events"><span className="nav-link">Events</span></Link>
                        </li>
                      </ul>
                      <ul>
                        <p>The regular operation in day-care centres is to start again with restrictions from September onwards, and emergency care will be provided. Since 14 May, daycare centres have been open initially for pre-school children with special needs. From 28 May, all preschool children are to return to the daycare centres. From June onwards, all other children will also be allowed to return to the daycare centres - but only on two days a week. Compulsory school attendance has been compulsory for all graduating classes since April 23rd, and high school graduates may decide for themselves whether they wish to attend school. Since 4 May, fourth graders have been going back to school. From the end of May, all pupils are to receive daily attendance lessons. </p>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    )
}

export default School